// import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
// import ThunderstormOutlinedIcon from "@mui/icons-material/ThunderstormOutlined";
import { Typography } from "@mui/material";
// import jwtAxios from "@crema/services/auth/jwt-auth";
import axios from "axios";
import { FETCH_ERROR } from "shared/constants/ActionTypes";
import { useDispatch } from "react-redux";
import { isEmptyObject } from "@crema/utility/Utils";

const Weather = () => {
    const dispatch = useDispatch();
    const [weatherData, setWeatherData] = useState({});
    const fetchWeather = async (latitude, longitude) => {
        const res = await axios.get(
            `https://api.openweathermap.org/data/2.5/weather`,
            {
                params: {
                    lat: latitude,
                    lon: longitude,
                    units: "metric",
                    appid: "96580c27a73a2c3bf2b8db59e08df267",
                },
            }
        );

        if (res.status === 200) {
            setWeatherData(res.data);
        }
    };
    const fetchRequest = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    fetchWeather(latitude, longitude);
                },
                (error) => {
                    // dispatch({
                    //     type: FETCH_ERROR,
                    //     payload:
                    //         error.code === 1
                    //             ? `${error.message} Kindly unblock location from location setting of browser/app.`
                    //             : error.message,
                    // });
                    console.error("Error getting user location:", error);
                }
            );
        } else {
            dispatch({
                type: FETCH_ERROR,
                payload: "Geolocation is not supported by this browser.",
            });
            console.error("Geolocation is not supported by this browser.");
        }
    };
    useEffect(() => {
        fetchRequest();
    }, []);
    if (!isEmptyObject(weatherData)) {
        return (
            <>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        /* px: "7.4px", */
                        pr: 3,
                    }}
                >
                    <Typography
                        sx={{
                            pr: 1,
                        }}
                    >
                        {`${weatherData?.name}, ${weatherData?.sys.country}`}
                    </Typography>
                    <img
                        title={weatherData?.weather[0].description}
                        src={`https://openweathermap.org/img/wn/${weatherData?.weather[0].icon}.png`}
                    />
                    <Typography
                        sx={{
                            pl: 1,
                        }}
                    >
                        {weatherData?.main.temp} &deg;C
                    </Typography>
                </Box>
            </>
        );
    }
    return <></>;
};

export default Weather;
